// diff.component.ts
import { Component, Input, OnChanges } from '@angular/core';
import * as DiffMatchPatch from 'diff-match-patch';

interface DiffPart {
  type: 'equal' | 'insert' | 'delete';
  text: string;
}

@Component({
  selector: 'fc-string-diff',
  standalone: false,
  template: `
    @for (part of parts; track $index) {
      <span [class]="part.type">{{ part.text }}</span>
    }
  `,
  styleUrls: ['./string-diff.component.scss'],
})
export class StringDiffComponent implements OnChanges {
  @Input() original = '';
  @Input() modified = '';

  parts: DiffPart[] = [];

  ngOnChanges(): void {
    const dmp = new DiffMatchPatch.diff_match_patch();
    const diffs = dmp.diff_main(this.original, this.modified);
    dmp.diff_cleanupSemantic(diffs);

    this.parts = diffs.map(([op, text]) => ({
      type: op === -1 ? 'delete' : op === 1 ? 'insert' : 'equal',
      text
    }));
  }
}
